export const GetApplicationUserEdit = "/ApplicationUser/GetApplicationUserEdit";

export const GetUser = "/ApplicationUser/GetUser";

export const ApplicationUserPaymentFeeWithUSDT =
  "/ApplicationUser/ApplicationUserPaymentFeeWithUSDT";
